<template>
    <div class="h-100">
        <search-bar
            v-if="options.EnableSearch"
            :field-placeholder-text="options.SearchBarPlaceholder"
            :search-page-url="options.SearchPageLink.Url"
            :always-open="true"
        />
        <div class="mega-menu-container grid-y align-justify">
            <div class="cell shrink">
                <div v-if="listIndex === -1">
                    <div
                        v-for="(element, i) in options.HeaderTopMenuElementModels"
                        :key="i"
                        class="mega-menu-item"
                    >
                        <span
                            v-if="element.MegaMenuMobileMenu !== null"
                            @click="showSubMenuN(i)"
                        >
                            <span
                                :data-clicklabel="element.Link.Text"
                                :data-clickaction="'click-header ' + websiteType"
                                data-clickcategory="header"
                                class="menu-item"
                                v-html="element.Link.Text"
                            /><span class="menu-item"> ></span>
                        </span>
                        <span v-else>
                            <span
                                :data-clicklabel="element.Link.Text"
                                :data-clickaction="'click-header ' + websiteType"
                                data-clickcategory="header"
                                class="menu-item"
                                @click="goToPage(element.Link.Url)"
                                v-html="element.Link.Text"
                            />
                        </span>
                    </div>
                </div>
                <category-list
                    :show="showSubMenu"
                    :list="megaMenuList"
                    :link="subMenuLink"
                    @reset="reset()"
                />
            </div>
            <div class="cell auto">
                <span />
            </div>
            <div class="cell shrink grid-x align-center">
                <div
                    v-if="options.BecomeMemberLink"
                    :data-clicklabel="options.BecomeMemberLink.Text"
                    :data-clickaction="'click-header ' + websiteType"
                    data-clickcategory="header"
                    class="button large"
                    @click="goToPage(options.BecomeMemberLink.Url)"
                    v-html="options.BecomeMemberLink.Text"
                />
                <a
                    v-if="options.MyPageMobileText"
                    :data-clicklabel="options.MyPageMobileText"
                    :data-clickaction="'click-header ' + websiteType"
                    data-clickcategory="header"
                    class="link margin-top"
                    @click="goToMyPage()"
                    v-html="options.MyPageMobileText"
                />
            </div>
        </div>
    </div>
</template>
<script>
import MegaMenuCategoryItemListVue from './MegaMenuCategoryItemList.vue';
import SearchBarVue from '../../Search/SearchBar.vue';

export default {
    name: 'MegaMenuSmallScreen',
    components: {
        'category-list': MegaMenuCategoryItemListVue,
        'search-bar': SearchBarVue

    },
    props: {
        options: {
            type: Object,
            default() {
                return {};
            }
        },
        websiteType: {
            type: String,
            default() {
                return '';
            }
        }
    },
    data() {
        return {
            listIndex: -1
        };
    },
    computed: {
        megaMenuList() {
            if (this.listIndex > -1 && this.options.HeaderTopMenuElementModels[this.listIndex].MegaMenuMobileMenu) {
                return this.options.HeaderTopMenuElementModels[this.listIndex].MegaMenuMobileMenu;
            }
            return undefined;
        },
        showSubMenu() {
            return this.megaMenuList !== undefined;
        },
        subMenuLink() {
            if (this.listIndex > -1 && this.options.HeaderTopMenuElementModels[this.listIndex].MegaMenuMobileMenu) {
                return this.options.HeaderTopMenuElementModels[this.listIndex].Link;
            }
            return undefined;
        }
    },
    mounted() {
    },
    methods: {
        showSubMenuN(i) {
            this.listIndex = i;
        },
        reset() {
            this.listIndex = -1;
        },
        goToMyPage() {
            this.goToPage(this.options.MyPageLink.Url);
        },
        goToPage(page) {
            window.location.assign(page);
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../header';

.mega-menu-container {
    padding: rem-calc(30px) rem-calc(37px);
    min-height: 100%;
    padding-bottom: $header-height-mobile+rem-calc(53px)+rem-calc(55px);

    & .link {
        text-decoration: none;
        font-size: 16px;
        font-weight: bold;

    }

    & .margin-top {
        margin-top: rem-calc(24px);
    }

}

</style>
